module.exports = __webpack_public_path__ + "static/media/health-products.e4118428.png";